export const DEFAULT_MAX_FILE_SIZE = 5 * 1024 * 1024

export interface DocumentTypeConfig {
  field: string
  label: string
  apiType: string
  required?: boolean
  accept?: string
  maxSize?: number
  colSpan?: "full" | 1 | 2
  tooltip?: string
}

export const DOCUMENT_TYPES: DocumentTypeConfig[] = [
  {
    field: "socialContract",
    label: "Contrato social da empresa contratada",
    apiType: "url_enterprise_contract",
    required: true,
    accept: "application/pdf",
    maxSize: DEFAULT_MAX_FILE_SIZE,
    colSpan: "full",
    tooltip: "É imprescindível que o nome do profissional contratado conste no contrato social",
  },
  {
    field: "addressProofPJ",
    label: "Comprovante de endereço (PJ)",
    apiType: "url_address_receipt",
    required: true,
  },
  {
    field: "bankAccountProofPJ",
    label: "Comprovante de conta bancária (PJ)",
    apiType: "url_bank_account_receipt",
    required: true,
  },
  {
    field: "addressProofPF",
    label: "Comprovante de endereço (PF)",
    apiType: "url_address_receipt",
    required: true,
  },
  {
    field: "cnpjCard",
    label: "Cartão do CNPJ",
    apiType: "url_enterprise_document",
    required: true,
    tooltip: "Com a data do mês atual e dados atualizados",
  },
  {
    field: "photoDocument",
    label: "Documento com foto (RG/CNH)",
    apiType: "url_document",
    required: true,
    tooltip: "Documento do representante legal/profissional contratado",
  },
  {
    field: "vaccinationCard",
    label: "Carteira de Vacinação Covid-19",
    apiType: "url_covid_vaccine_receipt",
    required: true,
  },
  {
    field: "drtDocument",
    label: "DRT ou similar",
    apiType: "url_drt",
    required: true,
    colSpan: "full",
  },
]
